import { inject, InjectionToken, Provider } from '@angular/core';

export interface ApiClientConfig {
  /** Root of the .NET backend, e.g. `https://api.sportellobalneari.it`. No trailing slash. */
  apiBaseUrl: string;
  /** Root of the CRM service, deployed apart from the portal API. No trailing slash. */
  crmApiBaseUrl: string;
  /** Mapbox public token, used by `MapboxApiService` (it talks to Mapbox, not our backend). */
  mapboxAccessToken?: string;
}

/**
 * Host-supplied API config, consumed by every service in this library.
 *
 * The apps each define their own `CONFIGURATION` token in `app.config.ts`, which a
 * library cannot reach. Apps wire this one with `provideApiClient(environment)`.
 */
export const API_CLIENT_CONFIG = new InjectionToken<ApiClientConfig>(
  'apiClientConfig',
);

export function provideApiClient(config: ApiClientConfig): Provider {
  return { provide: API_CLIENT_CONFIG, useValue: config };
}

/** `${apiBaseUrl}/${segment}` for services that build their base URL at field-init time. */
export function apiUrl(segment: string): string {
  return `${inject(API_CLIENT_CONFIG).apiBaseUrl}/${segment}`;
}
